import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "../../types/notification.types";

const notificationSlice = createSlice({
	name: "notifications",
	initialState,
	reducers: {
		markRead(state, action) {
			const uuid = action.payload;
			const target = state.notifications.find(n => n.uuid === uuid);
			if (target && !target.isRead) {
				target.isRead = true;
				state.unreadCount = Math.max(0, (state.unreadCount || 0) - 1);
			}
		},
		markReadOptimistic(state, action) {
			const id = typeof action.payload === "string" ? parseInt(action.payload, 10) : action.payload;
			const target = state.notifications.find(n => n.id === id);
			if (target && !target.isRead) {
				target.isRead = true;
				state.unreadCount = Math.max(0, (state.unreadCount || 0) - 1);
			}
		},
		dismiss(state, action) {
			const id = typeof action.payload === "string" ? parseInt(action.payload, 10) : action.payload;
			state.notifications = state.notifications.filter(n => n.id !== id);
		},
		resetNotifications(state) {
			state.notifications = [];
			state.page = 1;
			state.hasMore = true;
			state.loading = false;
			state.error = null;
		},
		setNotifications(state, action) {
			state.notifications = action.payload.notifications;
			state.page = action.payload.page;
			state.hasMore = action.payload.hasMore;
			state.unreadCount = action.payload.unreadCount || 0;
			state.loading = false;
		},
		addNotification(state, action) {
			state.notifications.unshift(action.payload);
			if (!action.payload?.isRead) {
				state.unreadCount = (state.unreadCount || 0) + 1;
			}
		},
		updateUnreadCount(state, action) {
			state.unreadCount = action.payload;
		},
	},
});

export const {
	markRead,
	markReadOptimistic,
	dismiss,
	resetNotifications,
	setNotifications,
	addNotification,
	updateUnreadCount,
} = notificationSlice.actions;
export default notificationSlice.reducer;
